import Text, { TextStyles } from '@cinch/oxd-components/text/src'
import cx from 'classnames'
import React from 'react'

import * as styles from './panel.module.css'

export enum PanelLevel {
  low = 'low',
  mid = 'mid',
  top = 'top',
}

export interface PanelProps {
  level?: PanelLevel
  isPadded?: boolean
  className?: string
  titleClass?: string
  title?: string
  subtitle?: string
  iconLeft?: any
  isBodyFlex?: boolean
  hasBorder?: boolean
}

const Panel: React.FC<PanelProps> = ({
  className = '',
  children,
  level,
  isPadded,
  title,
  subtitle,
  titleClass = '',
  iconLeft,
  isBodyFlex,
  hasBorder = true,
}) => (
  <div
    className={cx(styles.panel, className, {
      [styles.low]: level === PanelLevel.low,
      [styles.mid]: level === PanelLevel.mid,
      [styles.top]: level === PanelLevel.top,
      [styles.noBorder]: !hasBorder,
    })}
  >
    {iconLeft && <div className={styles.addornmentLeft}>{iconLeft}</div>}
    <div
      className={cx(styles.bodyContent, {
        [styles.noPadding]: !isPadded,
        [styles.bodyFlex]: isBodyFlex,
      })}
    >
      {title && (
        <Text
          type={TextStyles.menuTitle}
          element="div"
          className={cx(styles.title, titleClass)}
          data-testid="panel-title"
        >
          {title}
        </Text>
      )}
      {subtitle && (
        <Text type={TextStyles.body2} element="p" data-testid="panel-subtitle">
          {subtitle}
        </Text>
      )}
      {children}
    </div>
  </div>
)

Panel.defaultProps = {
  level: PanelLevel.low,
  isPadded: true,
}
;(Panel as any).levels = PanelLevel

export default Panel
